export class SliderChangeInfo {
  constructor(
    public zoom: number = 1,
    public move: number = 0,
    public recalc = false,
  ) {}
}
